export default "__VITE_ASSET__CcCm5gU5__"